var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"severity-count",style:(_vm.style)},[_vm._v(" "+_vm._s(_vm.getCount)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }